module.exports = __webpack_public_path__ + "static/img/szafa_22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_22.jpg
// module id = GYav
// module chunks = 0